
import Promessas from './1_Promessa';
import Beneficios from './2_Beneficios';
import Estrategias from './3_Estrategias';
import Proficionais from './4_Profissionais';
import Rodape from './9_Rodape'
import logo from '../assets/marca.png'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import Clientes from "./5_Clientes"
import Avaliacao from './6_Avaliacao';


function Home() {
  return (
  <>
      <header>
          <Promessas/>
      </header>
      <body className="w-full h-full bg-img_bg_fundo2 bg-no-repeat bg-center bg-cover">
            <Beneficios/>
            <Estrategias/>
            <Proficionais/>
            <Clientes/>
            <Avaliacao/>
          
            <Rodape/>
            <FloatingWhatsApp
        phoneNumber="5573981367231"
        accountName="Innovare"
        allowEsc
        allowClickAway
        notification
        notificationSound
        statusMessage = "Normalmente respondemos dentro de 20 minutos"
        chatMessage= "Olá!🤝 Como podemos ajudar?"
        avatar={logo}
      />
       </body>
       <futter>
       </futter>
     
   
  </>
  );
}

export default Home;
